import useNavSetting from './use-nav-setting';

export default { useNavSetting };
export { useNavSetting };
